import { render, staticRenderFns } from "./PayRecord.vue?vue&type=template&id=ff9276ea&scoped=true&"
import script from "./PayRecord.vue?vue&type=script&lang=js&"
export * from "./PayRecord.vue?vue&type=script&lang=js&"
import style0 from "./PayRecord.vue?vue&type=style&index=0&id=ff9276ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9276ea",
  null
  
)

export default component.exports